import numeral from "numeral";
import React from "react";
import { Button, Col, Form, Modal, Row, Tooltip, Typography } from "antd";
import { useWithdraw } from "hook/finance/withdraw/useWithdraw";
import { useSelector } from "react-redux";
import { financeLifeOpenWithdrawSelector } from "store/bailiff/finance/life/life.selector";
import { settingWithdrawAllSelector } from "store/bailiff/default/withdraw/setting_withdraw.selector";
import { defaultWalletAllSelector } from "store/bailiff/default/wallet/default_wallet.selector";
import WithdrawBankAccount from "./component/withdraw_bankaccount";
import WithdrawAmount from "./component/withdraw_amount";
import WithdrawBankName from "./component/withdraw_bankname";
import WithdrawBankFullName from "./component/withdraw_bankuser";
import WithdrawSavebank from "./component/withdraw_savebank";
import TriggerBanks from "../trigger/trigger_banks";
//
//component
//redux
//selector
//actions
//utils
//hook
//str
const DialogWithdraw = () => {
  // -------------------------- VAR -----------------------------
  const { handleClose, loading, handleWithdraw } = useWithdraw();
  const [form] = Form?.useForm();
  // -------------------------- STATE ---------------------------
  // -------------------------- REDUX ---------------------------
  const open = useSelector(financeLifeOpenWithdrawSelector);
  const wallet = useSelector(defaultWalletAllSelector);
  const setting = useSelector(settingWithdrawAllSelector);
  const min = setting?.min || 500000;
  const amount = wallet?.earn;
  const lock = wallet?.lock || 0;
  const remain = amount - lock;
  const label = numeral(min).format("0,0");
  // -------------------------- FUNCTION ------------------------
  // -------------------------- EFFECT --------------------------
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  const renderCard = () => {
    return (
      <div className="card-withdraw-balance">
        <div className="card-withdraw-star" />
        <div className="card-withdraw-balance-account">
          <div style={{ fontWeight: 600 }}>Tài khoản ví</div>
        </div>
        <div className="card-withdraw-balance-number">
          <div style={{ fontWeight: 600 }}>số dư</div>
          <div>
            <span className="mr-2 line-through">{renderLock()}</span>
            <span style={{ fontSize: 20, fontWeight: 700 }}>
              <Tooltip title="Số dư có thể rút">
                {numeral(remain).format("0,0")}
              </Tooltip>
            </span>{" "}
            VND
          </div>
        </div>
      </div>
    );
  };

  const renderLock = () => {
    if (lock > 0) {
      return (
        <Tooltip
          title={`Bạn đã rút ra ${numeral(lock).format("0,0")} vnđ nên số tiền này đang bị khoá`}
        >
          {numeral(lock).format("0,0")}
        </Tooltip>
      );
    }
  };
  // -------------------------- MAIN ----------------------------
  return (
    <Modal
      title="Tạo đơn rút tiền"
      footer={null}
      open={open}
      centered
      onCancel={() => handleClose(form)}
    >
      <Form layout="vertical" id="dialog-withdraw" form={form}>
        <Row gutter={[16, 16]} style={{ marginTop: 40 }}>
          <Col xl={24} lg={24} md={24} xs={24}>
            {renderCard()}
          </Col>
          <Col xl={24} lg={24} md={24} xs={24}>
            <Typography.Title style={{ marginTop: 8 }} level={5}>
              Thông tin người nhận
            </Typography.Title>
          </Col>
          <Col xl={24} lg={24} md={24} xs={24}>
            <WithdrawBankName />
          </Col>
          <Col style={{ marginTop: 16 }} xl={24} lg={24} md={24} xs={24}>
            <WithdrawBankAccount />
          </Col>
          <Col xl={24} lg={24} md={24} xs={24}>
            <WithdrawBankFullName />
          </Col>
          <Col xl={24} lg={24} md={24} xs={24}>
            <WithdrawSavebank />
          </Col>
          <Col xl={24} lg={24} md={24} xs={24}>
            <Typography.Title level={5}>Thông tin giao dịch</Typography.Title>
          </Col>
          <Col xl={24} lg={24} md={24} xs={24}>
            <WithdrawAmount />
          </Col>
          <Col xl={24} lg={24} md={24} xs={24}>
            <div style={{ color: "black", fontStyle: "italic" }}>
              * Nhập số tiền bạn cần rút, lưu ý số tiền rút ra tối thiểu phải
              lớn hơn {label} mỗi lần tạo đơn
            </div>
          </Col>
          <Col xl={24} lg={24} md={24} xs={24}>
            <Button
              loading={loading}
              onClick={() => handleWithdraw(form)}
              type="primary"
              block
              style={{ minHeight: 40 }}
            >
              Tạo đơn
            </Button>
          </Col>
        </Row>
        <TriggerBanks />
      </Form>
    </Modal>
  );
};
export default DialogWithdraw;
